module.exports = __webpack_public_path__ + "static/media/CAPM2024.62d4cd21.png";